module.exports = __webpack_public_path__ + "static/Frontastic-Logo-Gradient-2cda1687db0494ee2b2025fb43ddcf19.svg";